// Developed by Aptus Engineering, Inc. <https://aptusai.com>
// See LICENSE.md file in project root directory

export default (urls) => {
    for (const url of urls)
        if (window.location.href.includes(url)) return true;
    return false;
}